module.exports = __webpack_public_path__ + "static/maroon-wood-f83db4fb664ccd95c62ce444c10d9cc6.svg";